// Shared invoice calculation logic — single source of truth.
// Both PO Tracker and Invoice Tracker must use these functions.

export function getApproved(inv) {
  return Number(inv.amount_approved || 0);
}

export function getOutstanding(inv, paidAmount) {
  const approved = getApproved(inv);
  const total = Number(inv.total || 0);
  // Outstanding = approved minus paid. If nothing approved yet, use total.
  const base = approved > 0 ? approved : total;
  return Math.max(0, base - paidAmount);
}

export function getDisplayStatus(inv, paidAmount) {
  const total = Number(inv.total || 0);
  const approved = getApproved(inv);
  const outstanding = getOutstanding(inv, paidAmount);

  // Manual overrides take priority
  if (inv.status === 'disputed') return 'disputed';
  if (inv.status === 'hold') return 'hold';

  // Computed from numbers
  if (total > 0 && outstanding <= 0.01 && approved > 0) return 'paid';
  if (inv.status === 'paid') return 'paid';
  if (approved > 0 && approved >= total) return 'approved';
  if (approved > 0 && approved < total) return 'partial';
  return 'draft';
}

// Mutually exclusive due bucket. Returns exactly one of:
// 'overdue' | 'due_this_week' | 'due_now' | null
export function getDueBucket(inv, paidAmount) {
  const ds = getDisplayStatus(inv, paidAmount);
  if (ds !== 'approved' && ds !== 'partial') return null; // only approved invoices are "due"

  const outstanding = getOutstanding(inv, paidAmount);
  if (outstanding <= 0.01) return null;

  if (!inv.due_date) return 'due_now';

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayStr = today.toISOString().slice(0, 10);
  const cutoff = new Date(today);
  cutoff.setDate(cutoff.getDate() + 7);
  const cutoffStr = cutoff.toISOString().slice(0, 10);

  if (inv.due_date < todayStr) return 'overdue';
  if (inv.due_date <= cutoffStr) return 'due_this_week';
  return 'due_now';
}
